import React from "react";
import { useOutletContext } from "react-router-dom";
import { useRunData, useRunPicker } from "./useRunData";
import { PendingRow, Spinner } from "./Pending";

const KIND_LABEL = { client: "Client", competitor: "Competitor", other: "Third party" };

export default function TabSources() {
  const { report, reportId } = useOutletContext();
  const [runNumber, setRunNumber, runs] = useRunPicker(report);
  const { data, pending, error } = useRunData(reportId, runNumber, { includeAggregationsOnly: true });
  const agg = data?.aggregations || {};
  const domains = agg.mostUsedDomains || [];
  const clientPages = agg.clientMostReferencedPages || [];
  const competitorOnly = agg.competitorOnlyDomains || [];

  return (
    <div>
      <div className="run-picker">
        <label>Run:
          <select value={runNumber || ""} onChange={(e) => setRunNumber(Number(e.target.value))}>
            {runs.slice().reverse().map((r) => (
              <option key={r.runNumber} value={r.runNumber}>#{r.runNumber}</option>
            ))}
          </select>
        </label>
      </div>
      {error && <div className="error-message">{error}</div>}

      <h3>Most referenced domains</h3>
      <table className="runs-table">
        <thead><tr><th>Domain</th><th>Citations</th><th>Type</th></tr></thead>
        <tbody>
          {pending && <PendingRow cols={3} />}
          {!pending && domains.map((d) => (
            <tr key={d.domain}>
              <td>{d.domain}</td>
              <td>{d.count}</td>
              <td><span className={`kind-tag kind-${d.kind || "other"}`}>{KIND_LABEL[d.kind] || KIND_LABEL.other}</span></td>
            </tr>
          ))}
          {!pending && domains.length === 0 && <tr><td colSpan="3">No sources recorded.</td></tr>}
        </tbody>
      </table>

      <h3 style={{ marginTop: 24 }}>Cited where competitors appear and you don&apos;t</h3>
      <p className="muted" style={{ marginTop: 0 }}>
        Third-party sites the AI leaned on in answers that named a competitor but not {report.clientName}.
        Earning coverage or citations there is the most direct way in.
      </p>
      <table className="runs-table">
        <thead><tr><th>Domain</th><th>Citations</th></tr></thead>
        <tbody>
          {pending && <PendingRow cols={2} />}
          {!pending && competitorOnly.map((d) => (<tr key={d.domain}><td>{d.domain}</td><td>{d.count}</td></tr>))}
          {!pending && competitorOnly.length === 0 && <tr><td colSpan="2">None in this run.</td></tr>}
        </tbody>
      </table>

      <h3 style={{ marginTop: 24 }}>Client pages referenced</h3>
      {pending ? <Spinner size={20} /> : (
        <ul>
          {clientPages.map((p) => (<li key={p.url}><a href={p.url} target="_blank" rel="noreferrer">{p.url}</a> ({p.count})</li>))}
          {clientPages.length === 0 && <li>No client URLs cited.</li>}
        </ul>
      )}
    </div>
  );
}
